import React from 'react';
import Layout from '../../components/Layout';
import ListLayout from '../../components/Layout/ListLayout';
import BecomeHost from './BecomeHost';
import fetch from '../../core/fetch';
import { trackPageView } from '../../core/analytics.js';

// Redux Action
import { initialize } from 'redux-form';

const title = 'Add listing';

export default {
  path: '/add-listing/:listId?/:formPage?',

  async action({ params, store, query }) {
    // From Redux Store
    const isAuthenticated = store.getState().runtime.isAuthenticated;
    const isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
    const listingFields = store.getState().listingFields.data;

    // From URI
    const listId = isNaN(Number(params.listId)) ? null : Number(params.listId);
    const formPage = listId ? params.formPage : params.listId;
    const formBaseURI = '/add-listing/';

    if (!isAuthenticated && !isAdminAuthenticated) {
      return { redirect: '/login' };
    }
    if (!listId && !formPage) {
      trackPageView('/add-listing');
    }

    return {
      title,
      component: (
        <Layout>
          <BecomeHost
            listId={listId}
            title={title}
            formPage={formPage}
            formBaseURI={formBaseURI}
            query={query}
          />
        </Layout>
      ),
    };
  },
};



// WEBPACK FOOTER //
// ./src/routes/becomeHost/index.js